import { FormlyFieldConfig } from '@ngx-formly/core';

/**
 * Applies the `field-testid` wrapper to every keyed field automatically, so
 * `[data-testid="field-<key>"]` resolves for any field in the app with no
 * per-type or per-template instrumentation. Placed first so it wraps
 * outermost, around whatever the field's own type-specific wrapper(s)
 * (e.g. the third-party `@ngx-formly/material` form-field wrapper) render.
 */
export function testidExtension(field: FormlyFieldConfig) {
  if (field.key == null) {
    return;
  }

  if (field.wrappers && field.wrappers.indexOf('field-testid') !== -1) {
    return;
  }

  field.wrappers = ['field-testid', ...(field.wrappers || [])];
}
